import {changeFormat, getHourFromSec, meterToKilo, secToHourMinute,} from "@/components/tacho/common/CommonFunc";
import {setting} from '@/setting/index.js'
import {MeterStatusType} from "@/type";
import PayType, {convertPayTypeToTxt} from '@/type/PayType';

export function objectToQueryString(obj, removeStart = false) {
    if (!obj) {
        return '';
    }

    const keyValL = Object.keys(obj).filter(key => obj[key] !== undefined);

    if (!keyValL.length) {
        return '';
    }

    const start = removeStart ? '' : '?';
    return `${start}${keyValL.map(key => `${key}=${obj[key]}`).join('&')}`;
}

class drivingDailyEntity {
    constructor(allPayFare, allAddFare, allCallFare, allWorkDist, allWorkTime, allCarCount, allDriverCount, allBlankDist, allHipassFare) {
        this.allPayFare = allPayFare;
        this.allAddFare = allAddFare;
        this.allFare = allPayFare + allAddFare + allCallFare + allHipassFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.allDist = allWorkDist + allBlankDist;
        this.allHipassFare = allHipassFare;
    }

    fromMap(v) {
        this.allCarCount = v.allCarCount;
        this.allDriverCount = v.allDriverCount;
        this.allCallFare = v.allCallFare
        this.allWorkTime = getHourFromSec(v.allWorkTime);
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allPayFare = v.allPayFare;
        this.allAddFare = v.allAddFare;
        this.allFare = v.allPayFare + v.allAddFare + v.allCallFare + v.allHipassFare;
        this.allDist = meterToKilo(v.allWorkDist + v.allBlankDist).toFixed(1);
        this.allHipassFare = v.allHipassFare;
        return this;
    }

    fields() {
        return [
            {key: "allCarCount", label: "총 차량대수"},
            {key: "allDriverCount", label: "총 기사수"},
            {key: "allWorkTime", label: "총 실차시간"},
            {key: "allWorkDist", label: "총 실차거리"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allPayFare", label: "총 결제금액"},
            {key: "allCallFare", label: "총 호출요금"},
            {key: "allAddFare", label: "총 추가금액"},
            {key: "allFare", label: "총 합계금액"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allCallFare", label: "총 호출요금"},
        ]
    }
}

// ds.kang
class periodSummaryEntity {
    constructor(allPayFare, allAddFare, allCallFare, allWorkDist, allWorkTime, allCarCount, allDriverCount, allBlankDist, allHipassFare) {
        this.allPayFare = allPayFare;
        this.allAddFare = allAddFare;
        this.allFare = allPayFare + allAddFare + allCallFare + allHipassFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.allDist = allWorkDist + allBlankDist;
        this.allHipassFare = allHipassFare;
    }

    fromMap(v) {
        this.allCarCount = v.carCount;
        this.allDriverCount = v.driverCount;
        this.allCallFare = v.callFare
        this.allWorkTime = getHourFromSec(v.workTime);
        this.allWorkDist = meterToKilo(v.workDist).toFixed(1);
        this.allPayFare = v.payFare;
        this.allAddFare = v.addFare;
        this.allFare = v.fare;
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.allHipassFare = v.hipassFare;
        return this;
    }

    fields() {
        return [
            {key: "allCarCount", label: "총 차량대수"},
            {key: "allDriverCount", label: "총 기사수"},
            {key: "allWorkTime", label: "총 실차시간"},
            {key: "allWorkDist", label: "총 실차거리"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allPayFare", label: "총 결제금액"},
            {key: "allCallFare", label: "총 호출요금"},
            {key: "allAddFare", label: "총 추가금액"},
            {key: "allFare", label: "총 합계금액"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allCallFare", label: "총 호출요금"},
        ]
    }
}

class periodRecordEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, addFare, hipassFare, callFare) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.blankTime = allTime - workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.hipassFare = hipassFare;
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.stDtti;
        this.maxDtti = v.edDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.allTime - v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        this.addFare = v.addFare;
        this.hipassFare = v.hipassFare;
        this.callFare = v.callFare;
        return this;
    }

    fields() {
        return [
            {key: "viewYn", label: ""},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
        ]
    }
}

class drivingCloseDailyEntity {
    constructor(viewYn, allPayFare, allAddFare, allCallFare, allWorkDist, allWorkTime, allCarCount, allDriverCount, allHipassFare, allBlankDist, allBlankTime, allDist, allTime, allFare) {
        this.viewYn = viewYn;
        this.allPayFare = allPayFare;
        // this.allAddFare = allAddFare + allCallFare;
        this.allAddFare = allAddFare;
        this.allFare = allFare;//allPayFare + allAddFare + allCallFare + allHipassFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.allDist = allDist;
        this.allHipassFare = allHipassFare;
        this.allBlankDist = allBlankDist;
        this.allBlankTime = allBlankTime;
        this.allTime = allTime;
    }

    fromMap(v) {
        this.viewYn = v.viewYn;
        this.allCarCount = v.allCarCount;
        this.allDriverCount = v.allDriverCount;
        this.allWorkTime = getHourFromSec(v.allWorkTime);
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allPayFare = parseInt(v.allPayFare);
        // this.allAddFare = v.allAddFare + v.allCallFare;
        this.allAddFare = v.allAddFare;
        this.allFare = v.allFare;//v.allPayFare + v.allAddFare + v.allCallFare + v.allHipassFare;
        this.allCallFare = v.allCallFare;
        this.allDist = meterToKilo(v.allDist).toFixed(1);
        this.allHipassFare = v.allHipassFare;
        this.allBlankDist = meterToKilo(v.allBlankDist).toFixed(1);
        this.allBlankTime = getHourFromSec(v.allBlankTime);
        this.allTime = getHourFromSec(v.allTime);
        return this;
    }

    fields() {
        return [
            {key: "allCarCount", label: "총 차량대수"},
            {key: "allDriverCount", label: "총 기사수"},
            {key: "allWorkTime", label: "총 실차시간"},
            {key: "allWorkDist", label: "총 실차거리"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allPayFare", label: "총 결제금액"},
            {key: "allCallFare", label: "총 호출금액"},
            {key: "allAddFare", label: "총 추가금액"},
            {key: "allFare", label: "총 합계금액"},
            {key: "allDist", label: "총 운행거리"},
        ]
    }
}

class drivingMonthlyEntity {

    constructor(allPayfare, allAddFare, allCallFare, allWorkDist, allBlankDist, allWorkTime) {
        this.allPayfare = allPayfare;
        this.allAddFare = allAddFare + allCallFare;
        this.allFare = allPayfare + allAddFare + allCallFare;
        this.onDist = allWorkDist + allBlankDist;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
    }

    fromMap(v) {
        this.allPayfare = v.allPayfare;
        this.allAddFare = v.allAddFare + v.allCallFare;
        this.allFare = v.allPayfare + v.allAddFare + v.allCallFare;
        this.onDist = meterToKilo(v.allWorkDist + v.allBlankDist).toFixed(1);
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allWorkTime = secToHourMinute(v.allWorkTime).toFixed();
        return this;
    }

    fields() {
        return [
            {key: "allPayfare", label: "결제금액"},
            {key: "allAddFare", label: "추가금액"},
            {key: "allFare", label: "합계금액"},
            {key: "onDist", label: "총주행거리"},
            {key: "allWorkDist", label: "영업거리"},
            {key: "allWorkTime", label: "영업시간"},
        ]
    }
}

class tripDetailClosingDayDataEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, addFare
                , cashFare, cardFare, hipassFare, callFare, payType, payDtti, viewYn) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.blankTime = allTime - workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.hipassFare = hipassFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
        this.cashFare = cashFare;
        this.cardFare = cardFare;
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.allTime - v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        // this.addFare = v.addFare + v.callFare;
        this.addFare = v.addFare;
        this.hipassFare = v.hipassFare
        this.payType = convertPayTypeToTxt(v.payType);
        this.payDtti = v.payDtti;
        this.viewYn = v.viewYn;
        this.callFare = v.callFare;
        this.cashFare = v.cashFare;
        this.cardFare = v.cardFare;
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "cashFare", label: "현금 (원)"},
            {key: "cardFare", label: "카드금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
        ]
    }
}

class tripDetailDataEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, addFare, hipassFare, callFare, payType, payDtti, viewYn) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.blankTime = allTime - workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.hipassFare = hipassFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.allTime - v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        // this.addFare = v.addFare + v.callFare;
        this.addFare = v.addFare;
        this.hipassFare = v.hipassFare
        this.payType = convertPayTypeToTxt(v.payType);
        this.payDtti = v.payDtti;
        this.viewYn = v.viewYn;
        this.callFare = v.callFare;
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
        ]
    }
}

class tripDetailClosingDayCommuteDataEntity {
    constructor(seq, viewYn, addFare, allDist, allFare, callFare, allTime, blankDist, blankTime, carNum, createDtti, driverId, edDtti
            , hipassFare, payFare, stDtti, workDist, workTime, driveKey, hour, typeStDtti, typeEdDtti, cashFare, cardFare) {
        this.seq = seq;
        this.viewYn = viewYn;
        this.carNum = carNum; // 차량번호
        this.driverId = driverId; // 사원번호
        this.stDtti = stDtti; // 시작일자
        this.edDtti = edDtti; // 종료일자
        this.workTime = workTime; // 실차시간
        this.blankTime = blankTime; // 공차시간
        this.allTime = allTime; // 운행시간
        this.workDist = workDist; // 실차거리
        this.blankDist = blankDist; // 공차거리
        this.allDist = allDist; // 운행거리
        this.allFare = allFare; // 결제요금
        this.payFare = payFare; // 미터기 결제요금
        // this.addFare = addFare + callFare; // 추가결제요금
        this.callFare = callFare;
        this.addFare = addFare; // 추가결제요금
        this.hipassFare = hipassFare; // 하이패스요금
        this.createDtti = createDtti; // 생성일시
        this.driveKey = driveKey;
        this.hour = hour;
        this.typeStDtti = typeStDtti;
        this.typeEdDtti = typeEdDtti;
        this.unRegDtti = false;
        this.cashFare = cashFare;
        this.cardFare = cardFare;
    }

    fromMap(v) {
        this.seq = v.seq;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.blankTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.allDist).toFixed(1);
        this.allFare = parseInt(v.allFare);
        this.payFare = parseInt(v.payFare);
        // this.addFare = parseInt(v.addFare) + parseInt(v.callFare);
        this.callFare = parseInt(v.callFare);
        this.addFare = parseInt(v.addFare);
        this.hipassFare = parseInt(v.hipassFare);
        this.viewYn = v.viewYn;
        this.createDtti = v.createDtti;
        this.driveKey = v.driveKey;
        this.hour = v.hour;
        if (v.stDtti === null || v.edDtti === null) {
            this.unRegDtti = true;
        }
        this.cashFare = v.cashFare;
        this.cardFare = v.cardFare;
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "stDtti", label: "출근시간"},
            {key: "edDtti", label: "퇴근시간"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "cashFare", label: "현금 (원)"},
            {key: "cardFare", label: "카드금액 (원)"},
            {key: "allFare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
            {key: "createDtti", label: "갱신시간"},
        ]
    }
}
class tripDetailCommuteDataEntity {
    constructor(seq, viewYn, addFare, allDist, allFare, callFare, allTime, blankDist, blankTime, carNum, createDtti, driverId, edDtti, hipassFare, payFare, stDtti, workDist, workTime, driveKey, hour, typeStDtti, typeEdDtti) {
        this.seq = seq;
        this.viewYn = viewYn;
        this.carNum = carNum; // 차량번호
        this.driverId = driverId; // 사원번호
        this.stDtti = stDtti; // 시작일자
        this.edDtti = edDtti; // 종료일자
        this.workTime = workTime; // 실차시간
        this.blankTime = blankTime; // 공차시간
        this.allTime = allTime; // 운행시간
        this.workDist = workDist; // 실차거리
        this.blankDist = blankDist; // 공차거리
        this.allDist = allDist; // 운행거리
        this.allFare = allFare; // 결제요금
        this.payFare = payFare; // 미터기 결제요금
        // this.addFare = addFare + callFare; // 추가결제요금
        this.callFare = callFare;
        this.addFare = addFare; // 추가결제요금
        this.hipassFare = hipassFare; // 하이패스요금
        this.createDtti = createDtti; // 생성일시
        this.driveKey = driveKey;
        this.hour = hour;
        this.typeStDtti = typeStDtti;
        this.typeEdDtti = typeEdDtti;
        this.unRegDtti = false;
    }

    fromMap(v) {
        this.seq = v.seq;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.blankTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.allDist).toFixed(1);
        this.allFare = parseInt(v.allFare);
        this.payFare = parseInt(v.payFare);
        // this.addFare = parseInt(v.addFare) + parseInt(v.callFare);
        this.callFare = parseInt(v.callFare);
        this.addFare = parseInt(v.addFare);
        this.hipassFare = parseInt(v.hipassFare);
        this.viewYn = v.viewYn;
        this.createDtti = v.createDtti;
        this.driveKey = v.driveKey;
        this.hour = v.hour;
        if (v.stDtti === null || v.edDtti === null) {
            this.unRegDtti = true;
        }
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "stDtti", label: "출근시간"},
            {key: "edDtti", label: "퇴근시간"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "allFare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
            {key: "createDtti", label: "갱신시간"},
        ]
    }
}

// 개인택시 운행데이터 조회
class privateDrivingDataEntity {
    constructor(infoDtti, officeId, carNum, driverId, speed, dist, carX, carY, viewYn, apiDtti) {
            this.infoDtti = infoDtti,
            this.officeId = officeId,
            this.carNum = carNum,
            this.driverId = driverId,
            this.speed = speed,
            this.dist = dist,
            this.carX = carX,
            this.carY = carY,
            this.viewYn = viewYn,
            this.apiDtti = apiDtti
    }

    fromMap(v) {
            this.infoDtti = v.infoDtti,
            this.officeId = v.officeId,
            this.carNum = v.carNum,
            this.driverId = v.driverId,
            this.speed = v.speed,
            this.dist = meterToKilo(v.dist),
            this.carX = v.carX,
            this.carY = v.carY,
            this.viewYn = v.viewYn,
            this.apiDtti = v.apiDtti;

        return this;
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "speed", label: "차량속도"},
            {key: "dist", label: "이동거리 (KM)"},
            {key: "carX", label: "차량위도"},
            {key: "carY", label: "차량경도"},
            {key: "apiDtti" , label: "데이터 저장일시"}
        ]
    }
}

class drivingSearchDto {
    constructor(officeId, carNum, driverId, startDate, startDay, startTime, endDate, endDay, endTime, queryDate, payType, viewYn, excelType, routeType, partnerType, regionName) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.startDate = startDate;
        this.startDay = startDay;
        this.startTime = startTime;
        this.endDate = endDate;
        this.endDay = endDay;
        this.endTime = endTime;
        this.queryDate = queryDate;
        this.payType = payType;
        this.viewYn = viewYn;
        this.excelType = excelType;
        this.routeType = routeType;
        this.partnerType = partnerType;
        this.regionName = regionName;
    }
}

class drivingCloseSearchDto {
    constructor(officeId, carNum, driverId, startDate, startDay, startTime, endDate, endDay, endTime, queryDate, payType, viewYn, excelType, routeType, partnerType, regionName, searchType, workDate) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.startDate = startDate;
        this.startDay = startDay;
        this.startTime = startTime;
        this.endDate = endDate;
        this.endDay = endDay;
        this.endTime = endTime;
        this.queryDate = queryDate;
        this.payType = payType;
        this.viewYn = viewYn;
        this.excelType = excelType;
        this.routeType = routeType;
        this.partnerType = partnerType;
        this.regionName = regionName;
        this.searchType = searchType;
        this.workDate = workDate;
    }
}

const paymentTypeEnum = PayType

const getKeyByValue = (map, value) => {
    for (let [k, v] of Object.entries(map)) {
        if (value === v) return k;
    }
}

class drivingAggregateSummaryDto {
    constructor(payType, allPayFare, allHipassFare, allAddFare, allCallFare, allPayCount) {
        this.payType = payType
        this.allPayfare = allPayFare
        this.allHipassFare = allHipassFare
        this.allAddFare = allAddFare
        this.allFare = allPayFare + allAddFare + allCallFare + allHipassFare
        this.allCallFare = allCallFare;
        this.allPayCount = allPayCount
    }

    fromMap(v) {
        this.payType = v.payType
        this.allPayfare = v.allPayfare
        this.allHipassFare = v.allHipassFare
        this.allAddFare = v.allAddFare
        this.allFare = v.allPayfare + v.allAddFare + v.allCallFare + v.allHipassFare
        this.allCallFare = v.allCallFare
        this.allPayCount = v.allPayCount
        return this
    }

    add(v) {
        this.payType = 99
        v.map(e => {
            this.allPayfare += e.allPayfare
            this.allHipassFare += e.allHipassFare
            this.allAddFare += e.allAddFare + e.allCallFare
            this.allFare += e.allPayfare + e.allAddFare + e.allCallFare + e.allHipassFare
            this.allPayCount += e.allPayCount
        })
    }

    fields() {
        return [
            {key: "payType", label: "결제타입/금액"},
            {key: "allPayfare", label: "미터금액"},
            {key: "allCallFare", label: "호출요금"},
            {key: "allHipassFare", label: "통행요금"},
            {key: "allAddFare", label: "추가금액"},
            {key: "allFare", label: "합계금액"},
            {key: "allPayCount", label: "건수"},
        ]
    }
}

class drivingAggregateDetailDto {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, hipassFare, addFare, callFare, payType, payDtti, viewYn) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.hipassFare = hipassFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        this.callFare = v.callFare;
        this.hipassFare = v.hipassFare;
        this.addFare = v.addFare;
        this.payType = convertPayTypeToTxt(v.payType);
        this.payDtti = v.payDtti;
        this.viewYn = v.viewYn;
        return this;
    }

    fields() {
        return [
            {key: "viewYn", label: ""},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "workTime", label: "운행시간"},
            {key: "workDist", label: "운행거리 (KM)"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "payType", label: "결제타입"},
            {key: "payDtti", label: "결제시간"}
        ]
    }
}

class companyEntity {
    constructor(officeId, name, address, phone, receiptNm, createdAt, updatedAt, type, regionName, setTime, ceoName, ceoTel, fax, area, useYn, regDtti, settleType) {
        this.officeId = officeId;
        this.address = address;
        this.name = name;
        this.phone = phone;
        this.receiptNm = receiptNm;
        this.type = type;
        this.regionName = regionName;
        this.ceoName = ceoName;
        this.ceoTel = ceoTel;
        this.fax = fax;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.setTime = setTime;
        this.area = area;
        this.useYn = useYn;
        this.regDtti = regDtti;
        this.settleType = settleType;
    }

    fields() {
        return [
            {key: "officeId", label: "사업자번호"},
            {key: "address", label: "사업자주소"},
            {key: "name", label: "사업자명"},
            {key: "phone", label: "전화번호"},
            {key: "type", label: "유형"},
            {key: "area", label: "지역"},
            {key: "ceoName", label: "대표자명"},
            {key: "ceoTel", label: "대표전화"},
            {key: "setTime", label: "시간"},
            {key: "regDtti", label: "생성날짜"},
            {key: "settleTypeFormatted", label: "검색 기준"},
        ]
    }
}

class employeeEntity {
    constructor(employeeId, companyRegnum, employeeNum, driverId, carNum, employeeName) {
        this.employeeId = employeeId;
        this.companyRegnum = companyRegnum;
        this.employeeNum = employeeNum;
        this.employeeName = employeeName;
        this.driverId = driverId;
        this.carNum = carNum;
    }

    fields() {
        return [
            {key: "employeeNum", label: "사원번호"},
            {key: "displayEmployeeName", label: "기사명"},
            {key: "driverId", label: "운전자격번호"},
        ]
    }
}

class vehicleEntity {
    constructor(officeId, carNum, driverId, carType) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.carType = carType;
    }

    fields() {
        return [
            {key: "officeId", label: "운수사아이디"},
            {key: "carNum", label: "차량번호"},
            {key: "driverIdFormatted", label: "사원번호"},
            {key: "carTypeFormatted", label: "종류"}
        ]
    }
}

class transactionEntity {
    constructor(
        carNum,
        driverCertNumber,
        isOffice,
        carType,
        officeName,
        driverId,
        dtti,
        createdAt,
        fare,
    ) {
        this.carNum = carNum;
        this.driverCertNumber = driverCertNumber || '-';
        this.isOffice = isOffice;
        this.carType = carType;
        this.officeName = isOffice ? "법인" : "개인";
        if (officeName) {
            this.officeName = `법인 (${officeName})`;
        }
        this.driverId = driverId || '-';
        this.dtti = dtti;
        this.createdAt = createdAt;
        this.fare = fare;
    }

    toExcelRow() {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: this.carNum, t: "s", s: s},
            {v: this.officeName, t: "s", s: s},
            {v: this.driverId, t: "s", s: s},
            {v: this.driverCertNumber, t: "s", s: s},
            {v: this.dtti, t: "s", s: s},
            {v: this.createdAt, t: "s", s: s},
        ]
    }

    static getExcelColsDef() {
        return [
            {width: 24.0},
            {width: 24.0},
            {width: 15.0},
            {width: 12.0},
            {width: 21.0},
            {width: 21.0},
        ]
    }

    static getExcelHeaders() {
        let s = {
            alignment: {horizontal: "center"},
            font: {bold: true},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }

        return transactionEntity.fields().map(f => {
            return {v: f.label, t: "s", s: s}
        });
    }

    static fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "officeName", label: "차량종류"},
            {key: "driverId", label: "사원번호"},
            {key: "driverCertNumber", label: "운전자격번호"},
            {key: "dtti", label: "거래일시"},
            {key: "createdAt", label: "확인일시"},
        ]
    }

    static fromApi(data) {
        return new transactionEntity(
            data.carNum,
            data.driverCertNumber,
            data.office,
            data.carType,
            data.officeName,
            data.driverId,
            changeFormat(data.dtti, 'YYYY-MM-DD HH:mm:ss'),
            changeFormat(data.createdAt, 'YYYY-MM-DD HH:mm:ss'),
            data.fare,
        );
    }
}

class driveInfoDto {
    constructor(infoDtti, officeId, carNum, driverId, speed, dist, carX, carY, viewYn, apiDtti) {
        this.infoDtti = infoDtti;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.speed = speed;
        this.dist = dist;
        this.carX = carX;
        this.carY = carY;
        this.viewYn = viewYn;
        this.apiDtti = apiDtti;
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti;
        this.officeId = v.officeId;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.speed = v.speed;
        this.dist = meterToKilo(v.dist).toFixed(1);
        this.carX = v.carX.toString();
        this.carY = v.carY.toString();
        this.viewYn = v.viewYn;
        this.apiDtti = v.apiDtti;
        return this;
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "speed", label: "차량 속도"},
            {key: "dist", label: "이동 거리"},
            {key: "carX", label: "차량 위도"},
            {key: "carY", label: "차량 경도"},
            {key: "apiDtti", label: "데이터 저장일시"}
        ]
    }

}

class buttonEventDto {
    constructor(infoDtti, officeId, carNum, driverId, driveKey, driveSubkey, buttonVal, payType, fare, callFare, addFare, carX, carY, dist, apiDtti, viewYn, carType, cityName, hipassFare, voucherFare) {
        this.infoDtti = infoDtti;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driveKey = driveKey;
        this.driveSubkey = driveSubkey;
        this.buttonVal = buttonVal;
        this.payType = payType;
        this.fare = fare;
        this.callFare = callFare;
        this.addFare = addFare;
        this.carX = carX;
        this.carY = carY;
        this.dist = dist;
        this.viewYn = viewYn;
        this.apiDtti = apiDtti;
        this.carType = carType;
        this.cityName = cityName;
        this.hipassFare = hipassFare;
        this.voucherFare = voucherFare;
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti;
        this.officeId = v.officeId;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.driveKey = v.driveKey;
        this.driveSubkey = v.driveSubkey;
        this.buttonVal = `${MeterStatusType[v.buttonVal]}(${v.buttonVal})`;
        this.payType = `${PayType[v.payType]}`;
        this.fare = v.fare;
        this.callFare = v.callFare;
        this.addFare = v.addFare;
        this.carX = v.carX.toString();
        this.carY = v.carY.toString();
        this.dist = meterToKilo(v.dist).toFixed(1);
        this.viewYn = v.viewYn;
        this.apiDtti = v.apiDtti;
        this.carType = v.carType;
        this.cityName = v.cityName;
        this.hipassFare = v.hipassFare;
        this.voucherFare = v.voucherFare;
        return this;
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "driveKey", label: "순번"},
            {key: "driveSubkey", label: "타코용 서브키"},
            {key: "buttonVal", label: "미터기 상태"},
            {key: "payType", label: "결제타입"},
            {key: "fare", label: "요금"},
            {key: "callFare", label: "호출 요금"},
            {key: "addFare", label: "추가 요금"},
            {key: "hipassFare", label: "통행 요금"},
            {key: "voucherFare", label: "바우처 요금"},
            {key: "carX", label: "차량 위도"},
            {key: "carY", label: "차량 경도"},
            {key: "dist", label: "이동 거리"},
            {key: "apiDtti", label: "저장 일시"},
            {key: "carType", label: "영업 타입"},
            {key: "cityName", label: "영업 지역"}

        ]
    }
}

class privateButtonEventDto {
    constructor(infoDtti, officeId, carNum, driverId, driveKey, driveSubkey, buttonVal, payType, fare, callFare, addFare, carX, carY, dist, apiDtti, viewYn, carType, cityName, hipassFare, voucherFare) {
        this.infoDtti = infoDtti;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driveKey = driveKey;
        this.driveSubkey = driveSubkey;
        this.buttonVal = buttonVal;
        this.payType = payType;
        this.fare = fare;
        this.callFare = callFare;
        this.addFare = addFare;
        this.carX = carX;
        this.carY = carY;
        this.dist = dist;
        this.viewYn = viewYn;
        this.apiDtti = apiDtti;
        this.carType = carType;
        this.cityName = cityName;
        this.hipassFare = hipassFare;
        this.voucherFare = voucherFare;
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti;
        this.officeId = v.officeId;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.driveKey = v.driveKey;
        this.driveSubkey = v.driveSubkey;
        this.buttonVal = `${MeterStatusType[v.buttonVal]}(${v.buttonVal})`;
        this.payType = `${PayType[v.payType]}`;
        this.fare = v.fare;
        this.callFare = v.callFare;
        this.addFare = v.addFare;
        this.carX = v.carX.toString();
        this.carY = v.carY.toString();
        this.dist = meterToKilo(v.dist).toFixed(1);
        this.viewYn = v.viewYn;
        this.apiDtti = v.apiDtti;
        this.carType = v.carType;
        this.cityName = v.cityName;
        this.hipassFare = v.hipassFare;
        this.voucherFare = v.voucherFare;
        return this;
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "driveKey", label: "순번"},
            {key: "driveSubkey", label: "타코용 서브키"},
            {key: "buttonVal", label: "미터기 상태"},
            {key: "payType", label: "결제타입"},
            {key: "fare", label: "요금"},
            {key: "callFare", label: "호출 요금"},
            {key: "addFare", label: "추가 요금"},
            {key: "hipassFare", label: "통행 요금"},
            {key: "voucherFare", label: "바우처 요금"},
            {key: "carX", label: "차량 위도"},
            {key: "carY", label: "차량 경도"},
            {key: "dist", label: "이동 거리"},
            {key: "apiDtti", label: "저장 일시"},
            {key: "carType", label: "영업 타입"},
            {key: "cityName", label: "영업 지역"},
        ]
    }
}

class drivingGraphSummaryDto {
    constructor(allPayFare, allAddFare, allCallFare, allWorkDist, allBlankDist, allWorkTime, allBlankTime, allWorkCount, allCarCount, allDriverCount, carNum, driverId, summaryPay, allHipassFare,workTime,workDay) {
        this.allPayFare = allPayFare;
        this.allAddFare = allAddFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allBlankDist = allBlankDist;
        this.allWorkTime = allWorkTime;
        this.allBlankTime = allBlankTime;
        this.allWorkCount = allWorkCount;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.carNum = carNum;
        this.driverId = driverId;
        this.summaryPay = summaryPay;
        this.allDist = allWorkDist + allBlankDist;
        this.allTime = allWorkTime + allBlankTime;
        this.allHipassFare = allHipassFare;
        this.workTime = workTime;
        this.workDay = workDay;
    }

    fromMap(q, v, l) {
        this.allPayFare = v.allPayFare;
        this.allAddFare = v.allAddFare;
        this.allCallFare = v.allCallFare;
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allBlankDist = meterToKilo(v.allBlankDist).toFixed(1);
        this.allWorkTime = getHourFromSec(v.allWorkTime);
        this.allBlankTime = getHourFromSec(v.allBlankTime);
        this.allWorkCount = v.allWorkCount;
        this.allCarCount = v.allCarCount;
        this.allDriverCount = v.allDriverCount;
        this.carNum = q.carNum;
        this.driverId = q.driverId;
        this.summaryPay = l;
        this.allDist = meterToKilo(v.allWorkDist + v.allBlankDist).toFixed(1);
        this.allTime = getHourFromSec(v.allWorkTime + v.allBlankTime);
        this.allFare = v.allPayFare + v.allAddFare + v.allCallFare + v.allHipassFare;
        this.workTime = v.workTime;
        this.workDay = v.workDay;
        return this;
    }

    fields() {
        return [
            {key: "allFare", label: "총 합계금액"}, //0
            {key: "allAddFare", label: "총 추가금액"}, //1
            {key: "allCallFare", label: "총 호출금액"}, //2
            {key: "allWorkDist", label: "영업거리"},//3
            {key: "allBlankDist", label: "주행거리"},//4
            {key: "allWorkTime", label: "영업시간"},//5
            {key: "allBlankTime", label: "주행시간"},//6
            {key: "allWorkCount", label: "총 운행횟수"},//7
            {key: "allCarCount", label: "총 차량대수"},//8
            {key: "allDriverCount", label: "총 기사수"},//9
            {key: "carNum", label: "차량번호"},//10
            {key: "driverId", label: "사원번호"},//11
            {key: "allDist", label: "총 운행거리"},//12
            {key: "allTime", label: "총 영업시간"},//13
            {key: "workTime", label: "영업시간"},//14
            {key: "workDay", label: "영업일자"},//15

        ]
    }
}

class drivingGraphRecordDto {
    constructor(minDtti, maxDtti, infoDtti, state, workTime, workDist, fare, payType) {
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.infoDtti = infoDtti;
        this.state = state;
        this.workTime = workTime;
        this.workDist = workDist;
        this.fare = fare;
        this.payType = payType;
    }

    fromMap(v) {
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.infoDtti = v.infoDtti;
        this.state = v.state;
        this.workTime = secToHourMinute(v.workTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.fare = v.fare;
        this.payType = PayType[v.payType];
        return this;
    }

    fields() {
        return [
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            // {key: "infoDtti", label: "운행중"},
            // {key: "state", label: "운행상태"},
            {key: "workTime", label: "영업시간 (초)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "fare", label: "결제금액 (원)"},
            // {key: "payType", label: "결제타입"},
        ]
    }
}
class drivingGraphPrintDto {
    constructor(minDtti, maxDtti, infoDtti, state, workTime, workDist, fare, payType) {
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workDist = workDist;
        this.fare = fare;
    }

    fromMap(v) {
        this.minDtti = changeFormat(v.minDtti, 'HH:mm:ss');
        this.maxDtti = changeFormat(v.maxDtti, 'HH:mm:ss');
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.fare = v.fare;
        return this;
    }

    fields() {
        return [
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "fare", label: "결제금액 (원)"},
        ]
    }
}
class appmeterDto {
    constructor(appmeterId, mdn, officeId, officeNm, carNum, carVin, license, regionName, carType, unitSn, speedDownRatio, rpmDownRatio, distCorrection, regDt, createdAt, updatedAt) {
        this.appmeterId = appmeterId;
        this.mdn = mdn;
        this.officeId = officeId;
        this.officeNm = officeNm;
        this.carNum = carNum;
        this.carVin = carVin;
        this.license = license;
        this.regionName = regionName;
        this.carType = carType;
        this.unitSn = unitSn;
        this.speedDownRatio = speedDownRatio;
        this.rpmDownRatio = rpmDownRatio;
        this.distCorrection = distCorrection;
        this.regDt = regDt;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }

    fromMap(v) {
        this.appmeterId = v.appmeterId;
        this.mdn = v.mdn;
        this.officeId = v.officeId;
        this.officeNm = v.officeNm;
        this.carNum = v.carNum;
        this.carVin = v.carVin;
        this.license = v.license;
        this.regionName = v.regionName;
        this.carType = v.carType;
        this.unitSn = v.unitSn;
        this.speedDownRatio = v.speedDownRatio;
        this.rpmDownRatio = v.rpmDownRatio;
        this.distCorrection = v.distCorrection;
        this.regDt = v.regDt;
        this.createdAt = v.createdAt;
        this.updatedAt = v.updatedAt;
        return v;
    }

    fields() {
        return [
            {key: "appmeterId", label: "앱미터기 아이디"},
            {key: "mdn", label: "단말전화번호"},
            {key: "officeId", label: "사업자번호"},
            {key: "officeNm", label: "운송사업자명"},
            {key: "carNum", label: "차량번호"},
            {key: "carVin", label: "차대번호"},
            {key: "license", label: "자격면허번호"},
            {key: "carType", label: "유형"},
            {key: "region", label: "지역"},
            {key: "unitSn", label: "단말기 시리얼 번호"},
            {key: "speedDownRatio", label: "속도 감속률"},
            {key: "rpmDownRatio", label: "RPM 감속률"},
            {key: "distCorrection", label: "거리보정"},
            {key: "regDt", label: "설치등록일자"},
            {key: "createdAt", label: "생성일"},
            {key: "updatedAt", label: "수정일"}
        ];
    }
}

class drivingGraphDetailDto {
    constructor(speed, dist, infoDtti) {
        this.speed = speed;
        this.dist = dist;
        this.infoDtti = infoDtti;
    }
}

class drivingGraphOnHistDto {
    constructor(startDate, endDate) {
        this.startDate = startDate;
        this.endDate = endDate;
    }
}

class vehicleQueryParam {
    constructor(officeId, queryType, queryValue, carType) {
        this.officeId = officeId
        this.queryType = queryType
        this.queryValue = queryValue
        this.carType = carType
    }
}

class lastTransactionQueryParam {
    constructor(
        region,
        officeId,
        carNum,
        onlyWithOffice,
        onlyWithPayment,
        page,
        size,
    ) {
        this.region = region;
        this.officeId = officeId;
        this.carNum = carNum;
        this.onlyWithOffice = typeof onlyWithOffice === 'boolean' ? onlyWithOffice : null;
        this.onlyWithPayment = typeof onlyWithPayment === 'boolean' ? onlyWithPayment : null;
        this.page = page || 0;
        this.size = size || 10;
    }o

    toQueryParams() {
        return objectToQueryString(this);
    }
}

class companyQueryParam {
    constructor(officeId, name, address, phone, receiptNm, periodType, startDate, endDate, type, regionName, ceoName, ceoTel, fax, setTime, area) {
        this.officeId = officeId;
        this.name = name;
        this.address = address;
        this.phone = phone;
        this.receiptNm = receiptNm;
        this.periodType = periodType;
        this.startDate = startDate;
        this.endDate = endDate;
        this.type = type;
        this.regionName = regionName;
        this.ceoName = ceoName;
        this.ceoTel = ceoTel;
        this.fax = fax;
        this.setTime = setTime;
        this.area = area;
    }
}

class appmeterQueryParam {
    constructor(mdn, officeId, officeNm, carNum, carVin, license, region, carType, unitSn, startDate, endDate) {
        this.mdn = mdn;
        this.officeId = officeId;
        this.officeNm = officeNm;
        this.carNum = carNum;
        this.carVin = carVin;
        this.license = license;
        this.region = region;
        this.carType = carType;
        this.unitSn = unitSn;
        this.startDate = startDate;
        this.endDate = endDate;
    }
}

class employeeQueryParam {
    constructor(companyRegnum, queryType, queryValue) {
        this.companyRegnum = companyRegnum
        this.queryType = queryType
        this.queryValue = queryValue
    }
}

const jobTypeEnum = {
    A: "A",
    B: "B"
}

const jobPositionTypeEnum = {
    A: "A",
    B: "B"
}

const jobStateEnum = {
    Y: "Y",
    N: "N"
}

const drivingTypeEnum = {
    NORMAL: "법인",
    INDIVIDUAL: "개인"
}

const drivingStateEnum = {
    OPEN: "OPEN",
    CLOSE: "CLOSE"
}

const regionTypeEnum = {
    KRSEL: "KRSEL",
    KRSUO: "KRSUO",
    KRSGM: "KRSGM",
    KRCHO: "KRCHO",
    KRTAE: "KRTAE",
    KRPUS: "KRPUS"
}

const appmeterCarTypeEnum = {
    21: "NORMAL",
    22: "INDIVIDUAL"
}

const carTypeEnum = {
    NORMAL: "NORMAL",
    INDIVIDUAL: "INDIVIDUAL"
}

const companyTypeEnum = {
    NORMAL: "법인",
    INDIVIDUAL: "개인"
}

const periodTypeEnum = {
    CREATED: "CREATED",
    UPDATED: "UPDATED"
}
const baseUrl = `${setting.url.tacho}`
const tachodUrl = `${setting.url.tachod}`

class tachoDataDto {
    constructor(select, carNum, driverId, fileName) {
        this.select = select;
        this.carNum = carNum;
        this.driverId = driverId;
        this.fileName = fileName;
    }

    fromMap(v, date) {
        this.select = "";
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.fileName = `${date}_${v.carNum.slice(5, 9)}_${v.driverId}_1.txt`;
        return this;
    }

    toApiDto() {
        return {carNum: this.carNum, driverId: this.driverId};
    }

    fields() {
        return [
            {key: "select", label: ""},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "운전자"},
            {key: "fileName", label: "파일명"}
        ];
    }
}

class commuteManagementEntity {
    constructor(seq, carNum, driverId, stDtti, edDtti, officeId) {
        this.seq = seq;
        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.officeId = officeId;
    }

    fromMap(v) {
        this.seq = v.seq;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.officeId = v.officeId;
        return this;
    }

    fields() {
        return [
            {key: "isChecked", label: ""},
            {key: "driverId", label: "사원번호"},
            {key: "carNum", label: "차량번호"},
            {key: "stDtti", label: "출근시간"},
            {key: "edDtti", label: "퇴근시간"}
        ]
    }
}

const tachoEntity = {
    drivingDailyEntity,
    periodSummaryEntity,
    periodRecordEntity,
    drivingCloseDailyEntity,
    drivingMonthlyEntity,
    tripDetailClosingDayDataEntity,
    tripDetailDataEntity,
    tripDetailClosingDayCommuteDataEntity,
    tripDetailCommuteDataEntity,
    privateDrivingDataEntity,
    drivingSearchDto,
    drivingCloseSearchDto,
    paymentTypeEnum,
    drivingAggregateSummaryDto,
    drivingAggregateDetailDto,
    companyEntity,
    vehicleEntity,
    transactionEntity,
    driveInfoDto,
    buttonEventDto,
    drivingGraphSummaryDto,
    drivingGraphPrintDto,
    drivingGraphRecordDto,
    appmeterDto,
    drivingGraphDetailDto,
    drivingGraphOnHistDto,
    jobTypeEnum,
    jobPositionTypeEnum,
    jobStateEnum,
    drivingTypeEnum,
    drivingStateEnum,
    regionTypeEnum,
    carTypeEnum,
    companyTypeEnum,
    periodTypeEnum,
    getKeyByValue,
    vehicleQueryParam,
    lastTransactionQueryParam,
    appmeterCarTypeEnum,
    appmeterQueryParam,
    companyQueryParam,
    employeeEntity,
    employeeQueryParam,
    baseUrl,
    tachodUrl,
    tachoDataDto,
    commuteManagementEntity,
    privateButtonEventDto
}

export default tachoEntity
